import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { VariableTypesPage } from "./-variables/variable-types.page";

export const Route = createFileRoute("/content/variables/")({
  validateSearch: validateGridSearch,
  component: VariableTypesPage,
});
